import React, { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function Admin() {
  const { user } = useAuth();
  const [seeding, setSeeding] = useState(false);
  const [progress, setProgress] = useState({ inserted: 0, remaining: 0, total_in_db: 0 });

  const runSeed = async (batch = 40) => {
    setSeeding(true);
    try {
      const r = await api.post("/admin/seed", { batch_size: batch });
      setProgress({ inserted: r.data.inserted, remaining: r.data.remaining_to_seed, total_in_db: r.data.total_in_db });
      toast.success(`Seeded ${r.data.inserted} · ${r.data.total_in_db} total`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Seed failed");
    } finally { setSeeding(false); }
  };

  const runFull = async () => {
    setSeeding(true);
    let total = 0;
    while (true) {
      try {
        const r = await api.post("/admin/seed", { batch_size: 40 });
        total += r.data.inserted;
        setProgress({ inserted: total, remaining: r.data.remaining_to_seed, total_in_db: r.data.total_in_db });
        if (r.data.inserted === 0) break;
      } catch (e) {
        toast.error("Failed at " + total);
        break;
      }
    }
    setSeeding(false);
    toast.success(`Complete: ${total} seeded`);
  };

  if (!user?.is_admin) return <Layout><div className="max-w-3xl mx-auto px-6 py-16">Admin only.</div></Layout>;

  return (
    <Layout>
      <div className="max-w-3xl mx-auto px-6 py-12 fade-in">
        <h1 className="font-serif text-4xl font-medium mb-6">Admin</h1>
        <div className="border border-border rounded-md p-6 bg-card">
          <h2 className="font-serif text-xl mb-3">Seed database</h2>
          <p className="text-sm text-muted-foreground mb-6">Loads all 331 TVDE questions and uses Claude Sonnet 4.5 to determine the correct answer for each. Run in batches of 40. Total in DB: <span className="font-mono font-semibold">{progress.total_in_db}</span></p>
          <div className="flex gap-3 flex-wrap">
            <Button onClick={() => runSeed(40)} disabled={seeding} data-testid="btn-seed-batch" className="bg-[hsl(var(--accent))] hover:bg-[hsl(var(--accent))]/90 rounded-full">
              {seeding && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Seed 40 more
            </Button>
            <Button onClick={runFull} disabled={seeding} variant="outline" data-testid="btn-seed-all" className="rounded-full">
              {seeding && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Seed everything
            </Button>
          </div>
          {progress.inserted > 0 && (
            <div className="mt-6 font-mono text-xs">
              Last run: <span className="font-semibold">{progress.inserted}</span> inserted · <span className="font-semibold">{progress.remaining}</span> remaining
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}
